import { render, staticRenderFns } from "./SocialProgramView.vue?vue&type=template&id=8ace7a1a"
import script from "./SocialProgramView.ts?vue&type=script&lang=ts&external"
export * from "./SocialProgramView.ts?vue&type=script&lang=ts&external"
import style0 from "./SocialProgramView.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports